module.exports = {
    login:{
        title : 'this title',
        username : '请输入用户名',
        password : '请输入密码',
        email : '请输入电子邮箱',
        phone : '请输入手机号码',
        send : '发送',
        vcode : '输入邮箱收到的验证码',
        password_confim : '再次输入密码,并确保两次密码一致',
        noemail:'邮箱地址不能为空',
        nophone:'手机号码不能为空',
        nopwd:'密码不能为空',
        nopwdconfim:'密码确认不能为空',
        noverCode:'校验码不能为空',
        nocode:'验证码不能为空',
        pwdconfimerr:'两次密码不一致！',
        noagreement:'请先勾选同意平台《隐私政策》和《用户协议》' ,
    },
    menu:{
        work_manag:'作品管理',
        work_add:'创建作品' ,
        base_info:'基本信息' ,
    },
    home:{
        personal_info:'个人信息' ,
        exit:'退出' ,
    },
    _login:'登录',
    _register:'注册',
    _reset:'重置',
    _web_title:'创作者',
    _writer_agreement: '勾选即代表同意《创作者协议》',
    _mail:'邮箱',
    _nick_name:'昵称',
    _pen_name:'笔名',
    _address:'地址',
    _region:'国家/地区',
    _id_number:'证件号码',
    _age_type:'年龄类别',
    _country_placeholder:'请选择你所在的国家或者地区' ,
    _imadult:"我是成年人",
    _imminor:"我是未成年人",
    _real_name:'真实姓名',
    _photo_id:'证件照片',
    _cancel:'取消',
    _ok:'确认',
    _male:'男',
    _gender:'男频/女频',
    _female:'女',
    _action:'操作',
    _edit:'编辑',
    _loading:'加载中...',
    _delete:'删除',
    _select_file:'选择文件',
    _upload_format_err:'上传的图片格式不正确',
    _upload_size_err:'上传图片的大小不能大于1M',
    _upload_widhigh_err:'上传的图像宽450像素，高600像素',
    _continue_dailog:'是否确实要继续？',
    _public_dailog:'发布后小说信息就会锁定不能再编辑了！',
    _public_chapter_dailog:'发布后，该章节会锁定不再可编辑!',
    _attention:'注意',
    _add:'添加',
    _add_whole:'整本添加',
    _release_selected:'发布所有已选章节',
    _contact_desc:' *如果有任何问题或者疑问 请与我们取得联系.',
    _index:'序号',
    _back:'返回',
    _contact_number:'联系信息',
    _required_mail:'邮箱不能为空',
    _required_pen_name:'笔名不能为空',
    _required_phone:'联系方式信息不能为空',
    _required_photo:'证件正面照片不能为空',
    _required_region:'国家/地区信息不能为空',
    _required_real_name:'真实姓名不能为空',
    _required_age_type:'年龄类别信息不能为空',
    _required_address:'地址不能为空',
    _required_id_number:'证件号码不能为空!',
    _input_holder_cover:"1. 封面中需要包含书籍的正式名称 <br/>2. 封面不得包含血腥和暴力内容<br/>3. 官网保留直接移除任何非法封面的权利<br/>",
    _input_holder_age:'根据小说的内容，哪些年龄段适合读者阅读',
    _required_book_title:"书籍名称不能为空!",
    _required_book_desc:"内容简介信息不能为空!",
    _required_book_cateids:"书籍分类信息不能为空!",
    _required_book_age_limit:"适合受众的年龄信息不能为空!",
    _required_book_sex:"适合受众的性别信息不能为空",
    _required_book_iswz:"书籍的连载状态不能为空!",

    placeholder_spreator_type:"请选择分章方式",
    spreator_type:'分章方式',
    separator:'分隔符',
    number_of_chars:'按字数分章',
    placeholder_separ:'请输入章节分隔符，并注意输入法全半角状态',
    placeholder_number:'请输入每章大约包含的字符数，系统会在满足字数后就近按自然段落分章',
    hit_whole_add:'注：整本书可以TXT格式上传，上传后所有之前上传的章节将被清除',
    books:{
        classification:'分类',
        all:'全部',
        hots:'人气',
        author:'作者',
        finished:'已完结',
        serial:'连载中',
        nofound:'没有找到相关结果',
        changeCls:'换个分类再试一下',
        bookTitle:'书名',
        long:'长篇',
        short:'短篇',
        collection:'收藏',
        startReading:'开始阅读',
        checkStus:'审核',
        unpublished:'未发布',
        checking:'审核中',
        failed:'已拒绝',
        passed:'已通过',
    },
    novelist:{
        cover:'封面图',
        booktitle:'书名',
        chapters_num:'章节数',
        finished_status:'进度',
        chapters:'章节',
        release:'发布',
        desc:'简介描述' ,
        chapter_title:'标题',
        chapter_content:'内容',
        chapter_content_place:'请输入章节内容',
        chapter_index:'章节序号',
        columns:'发布栏目'
    },
    index:{
        more:'更多'
    },

    info:{
        catalogue:'目录',
        mobileReading:'手机阅读',
        download:'下载',
        freeReading:'免费阅读',
        moreFree:'查看更多免费书籍',
        interact:'可以与作者互动哦',
        pChapter:'上一章',
        nChapter:'下一章',
        tChapters:'总章节',
        chapters:'章',
        introduction:'作品简介',
        recentUpdates:'最近更新',

    },
    intro:{

    },
    news_info:{
        'updateAt':'更新时间',

    },
    search:{
        serachPlaceholder:'请输入书名或者作者名！',
        search:'搜索',
    },
    tops:{
        rankExplain:'榜单说明',
        explain1:'1、读完率分为10万字/30万字/50万字/80万字/100万字5个档位，仅显示最高档数据，排序依据是已有字数读完率的加权计算值，字数越多，权重越高；',
        explain2:'2、排行榜每天更新',
        explain3:'3、分类榜按原创小说读完率排序' ,
    },
    _home:'首页',
    status:'状态',
    default:'默认',
    privacyClause:'隐私条款',
    relatedResult:'相关结果' ,
    total:'共',
    all:'全部',
    screen:'筛选',
    agreement:'用户协议',
    loading:'数据加载中',
    writersZone:'作家专区',
    rankingList:'排行榜',
    writerWelfare:'作家福利' ,
    library:'书库',
    attention:'请使用者仔细阅读'
}